export enum EStatus {
    unknown=0, Created=1,Changed,Deleted,Saved
}